'use strict';

import {init as cookieSetter } from '../../cookie_setter';

export default class servicePage {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
    }

    bindHandlers() {
        let _self = this;

        $('.add-to-cart-item').on('click', function(){

            if (false === _self.opt.loggedIn) {
                cookieSetter.setCookie('service_order_not_logged_in', '1');
                window.location.href = _self.opt.loginPath;
                return false;
            }

            let btn = $(this);
            btn.toggleClass('cart-add');
            btn.prop('disabled', true);

            let status = btn.hasClass('cart-add') ? 'add' : 'remove'

            $.post(_self.opt.serviceOrderPath, {service: btn.attr('id'), status: status}).done(function (data) {
                if (data.success) {
                    window.location.reload();
                }
            })
        });
    }
}